export default __webpack_public_path__ + "static/media/uploadevaluation.57860fde.svg";